// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import request from './utile/request';
import requestOrder from "./utile/requestOrder";
import permission from './permission'
import has from './utile/btnPermissions'
import '@/assets/iconfont/iconfont.css'
import '@/assets/iconfont2/iconfont.css'
import { message } from './utile/resetMessage';
import VueCropper from 'vue-cropper'

// // 引入echarts
import echarts from "echarts";
// 引入复制
import VueClipboard from 'vue-clipboard2';
import Base64 from './utile/base64.js';//参数加密

// 引入自定义 消息推送全局组件
import messagePush from './components/messagePush/messagePush.vue'
Vue.use(messagePush);
Vue.component('messagePush', messagePush);    //初始化消息推送组件
Vue.use(VueCropper)


import VueBus from 'vue-bus';
Vue.use(VueBus);//EventBus

// // 全局获取缓存数据
Vue.prototype.resetSetItem = function (key, newVal) {
  if (key === 'messageNumber') {
    // 创建一个StorageEvent事件
    var newStorageEvent = document.createEvent('StorageEvent');
    const storage = {
        setItem: function (k, val) {
            sessionStorage.setItem(k, val);
            // 初始化创建的事件
            newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);
            // 派发对象
            window.dispatchEvent(newStorageEvent)
        }
    }
    return storage.setItem(key, newVal);
  }
},
// Vue.prototype.resetSetItem('messageNumber', 'false');

// 全局获取缓存数据结束

Vue.config.productionTip = false
Vue.use(ElementUI, { size: 'small', zIndex: 3000 });
Vue.prototype.$Base64 = Base64;

Vue.prototype.$message = message; // 这一个操作一定要放在Vue.use(ElementUI) 后面
Vue.prototype.$request = request;
Vue.prototype.$echarts = echarts;
Vue.prototype.$orderRequest = requestOrder;
Vue.use(VueClipboard)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App,messagePush },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js